import Common from "../../../../Common";

export interface Body {
	selection: number
	pbx_destination_id: id
	description: string
}

const Item = class extends Common {
	create = (userId: id, ivrId: id, body: Body) =>
		this.post(`/user/${userId}/profile/ivr/${ivrId}/item`, body);
}

export default Item
